<mat-toolbar>
  <button mat-icon-button (click)="sidenav.toggle()" id="menuIcon" aria-label="Example icon-button with menu icon">
    <span class="material-symbols-outlined">menu</span>
  </button>
  <a [routerLink]="'/home'" *ngIf="!isMobile">
    <img src="Logo_Small.png" alt="Company Logo" class="logo-image" />
  </a>
  <span class="spacer"></span>

  <ng-container *ngFor="let item of menuItems">
    <ng-container *ngIf="item.isIcon; else textMenuItem">
      <!-- Render the icon for mobile -->
      <a mat-button [routerLink]="item.link" class="menuItems">
        <span class="material-symbols-outlined">home</span>
      </a>
    </ng-container>
    <ng-template #textMenuItem>
      <!-- Render the label for text-based menu items -->
      <a mat-button [routerLink]="item.link" class="menuItems" routerLinkActive="active-menu-item">
        {{ item.label | translate }}
      </a>
    </ng-template>
  </ng-container>
  <span class="spacer"></span>
  <button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-button" (menuOpened)="langMenuOpened()" (menuClosed)="langMenuClosed()">
    <span class="material-symbols-outlined">language</span>
    <div *ngIf="menuOpen" class="language-caret"></div> <!-- Caret below the language icon -->
  </button>
  <mat-menu #languageMenu="matMenu">
    <button mat-menu-item (click)="useLanguage('de')">Deutsch</button>
    <button mat-menu-item (click)="useLanguage('en')">English</button>
  </mat-menu>
  <a mat-button class="bookingButton" (click)="navigateToContact()">{{'menu.bookingButton' | translate}}</a>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #sidenav [fixedInViewport]="true" [fixedTopGap]="55" mode="over">
    <div class="side-nav-items">
      <ng-container *ngFor="let item of menuItems">
        <a (click)="sidenav.close()" mat-button [routerLink]="item.link" routerLinkActive="active-side-menu-item"
          class="side-menu-item">
          <ng-container *ngIf="item.isIcon; else textSideMenuItem">
            <span class="material-symbols-outlined">home</span>
          </ng-container>
          <ng-template #textSideMenuItem>
            {{ item.label | translate }}
          </ng-template>
        </a>
      </ng-container>
    </div>
  </mat-sidenav>
</mat-sidenav-container>